import React from 'react';
import classNames from 'classnames';
import './BackButton.pcss';
import { ArrowLeftOutlined } from '@ant-design/icons';

type Props = {
  className?: string;
  onClick?: () => void;
  text?: string;
};

export const BackButton = ({ className, onClick, text = 'Back' }: Props) => {
  return (
    <div className={classNames(className, 'c-back-button')} onClick={onClick}>
      <ArrowLeftOutlined />
      {text}
    </div>
  );
};
